import React from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router';
import '@ant-design/v5-patch-for-react-19';
import routes from './routes';
import 'antd/dist/reset.css';
import './App.css';

const router = createBrowserRouter(routes);

const App: React.FC = () => {
  return <RouterProvider router={router} />;
};

export default App;
